// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MangoHubAddress {
    'addressTypeDescription': string;
    'address1': string;
    'address2': string;
    'city': string;
    'state': string;
    'zip': string;
    'geocoding': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MangoHubAddress>> = [
        {
            "name":     "addressTypeDescription",
            "baseName": "addressTypeDescription",
            "type":     "string"
        },
        {
            "name":     "address1",
            "baseName": "address1",
            "type":     "string"
        },
        {
            "name":     "address2",
            "baseName": "address2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "zip",
            "baseName": "zip",
            "type":     "string"
        },
        {
            "name":     "geocoding",
            "baseName": "geocoding",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MangoHubAddress.attributeTypeMap;
    }
}
